export { CorporativoOnboardingWelcomeRegional } from "./CorporativoOnboardingWelcomeRegional";
